<div class="prescription-size" mat-dialog-content>
  @if (this.isInBulk) {
    <div class="count-progress">
      <p>Progresso de Liberação de Medicamentos</p>
      <mat-progress-bar mode="determinate" [value]="this.progressDispensation"></mat-progress-bar>
      <div>
        <span>{{indexPrescription+1}}/{{this.listPrescription.length}} selecionado(s)</span>
      </div>
    </div>
  }
  <div class="mat-dialog-content">
    <div class="head-exam-modal-list">
      <h2>{{this.prescriptionMedicineStruct.medicineName}}</h2>
    </div>
    <div class="tag-container">
      <!-- <ng-container *ngFor="let tag of medicineTagUtilsService.getMainTags(this.prescriptionMedicineStruct.listTags)">
                <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                    'color': 'white' } : {}">{{tag.tagName}}</span>
    </ng-container>
    <span *ngIf="medicineTagUtilsService.getExtraTags(this.prescriptionMedicineStruct.listTags).length > 0" class="tag-header-prescription more-tags"
      matTooltip="{{ medicineTagUtilsService.getTooltipText(this.prescriptionMedicineStruct.listTags) }}" matTooltipClass="tag-tooltip">
      +{{ medicineTagUtilsService.getExtraTags(this.prescriptionMedicineStruct.listTags).length }}
    </span> -->
    @for (tag of this.prescriptionMedicineStruct?.listTags; track tag) {
                <span class="tag-header-prescription" [ngStyle]="tag.colorCode ? {'background-color': tag.colorCode, 
                    'color': 'white' } : {}">{{tag.tagName}}</span>
    }
  </div>

  <div class="body-exam-modal-list">
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      <div class="row">
        <div class="col-12">
          <label>Paciente: </label>
          <span> {{this.episode.patientSocialName? this.episode.patientSocialName :
          this.episode.patientName}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label class="label-doctor">Dados selecionados pelo médico: </label>
        </div>
      </div>
      <div class="row doctor-request">
        <div class="col-12">
          <label>Quantidade solicitada: </label>
          <span> {{this.quantityDoctor? this.quantityDoctor : 0}} {{ doseToAdministeredName }}</span>
          <span> | </span>
          <label>Quantidade já dispensada: </label>
          <span> {{this.quantityReleased}}</span>
          <span> | </span>
          <label>Apresentação escolhida: </label>
          <span> {{this.presentationTypeDoctor}}</span>
        </div>
      </div>
      <div class="division-line"></div>
      <div class="row">
        @if (storage) {
          <div class="col-12">
            <p><label class="label-storage">Estoque recomendado:
            {{storage.idStorage}}</label><span>Validade:
            {{storage.dateExpiration |
          date:'dd/MM/yyyy'}}</span>
        </p>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <button mat-flat-button color="primary" class="btn-block" type="button"
        (click)="openBarCodeModal()" [disabled]='!isValid'>
        <span>Dar baixa no estoque</span>
      </button>
    </div>
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Estoque utilizado:</mat-label>
        <input matInput type="number" [value]="barcodeValue" disabled>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Unidade</mat-label>
        <mat-select formControlName="idMeasurementUnit">
          @for (item of measurementUnitList; track item) {
            <mat-option [value]="item.idMeasurementUnit">
              {{item.measurementUnitName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Apresentação</mat-label>
        <mat-select formControlName="idPresentationType">
          @for (item of presentationList; track item) {
            <mat-option
              [value]="item.idMedicinePresentationType">
              {{item.medicinePresentationTypeName}}
            </mat-option>
          }
        </mat-select>
        @if (presentationOthersEnum == idMedicinePresentationType) {
          <mat-hint>
          {{medicinePresentationOther}}</mat-hint>
        }
      </mat-form-field>
    </div>
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Local</mat-label>
        <mat-select formControlName="idLocation">
          @for (item of listLocation; track item) {
            <mat-option [value]="item.idLocation">
            {{item.locationName}}</mat-option>
          }
        </mat-select>
        @if (model.get('idLocation')?.invalid) {
          <mat-error>Informe o local</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Quantidade</mat-label>
        <input matInput type="text" formControlName="quantity" min="0.001"
          appDecimalQuantityValidator>
          @if (amountRemaining) {
            <span matSuffix>{{ amountRemaining }}</span>
          }

          @if (model.get('quantity')?.invalid) {
            <mat-error>A quantidade tem que ser maior que
            0</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Dose a ser administrada</mat-label>
          <mat-select formControlName="idDoseToAdministered" placeholder="Selecione ...">
            @for (item of listDoseToAdministered; track item) {
              <mat-option
                [value]="item.idDoseToAdministered">
                {{item.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Total em 24h:</mat-label>
          <input matInput type="number" formControlName="calculatedTotalQuantity">
          <span matSuffix>{{ doseToAdministeredName }}</span>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      @if (model.get('tagsTooltipText')?.value) {
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline" [disabled]="true">
            <mat-label>Tags</mat-label>
            <input matInput type="text" formControlName="tagsTooltipText">
          </mat-form-field>
        </div>
      }
      <div>
        <div class="additional-itens-header">
          <h2>Materiais e quantidades adicionais</h2>
          <div class="col-12 col-md-4">
            <button mat-flat-button color="primary" type="button" class="btn-block"
              (click)="openAdditionalItemsModal()">
              @if (isLoading == false) {
                <span>Adicionar/editar</span>
              }
              @if (isLoading == true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"
                ></mat-spinner>
              }
            </button>
          </div>
        </div>
        <div>
          @if ((!listAdditionalItemsForRequest || listAdditionalItemsForRequest.length == 0) && (!listAdditionalMedicinesForRequest || listAdditionalMedicinesForRequest.length == 0)) {
            <app-empty-list
            [message]="'Não há materiais adicionais'"></app-empty-list>
          }
          @if ((listAdditionalItemsForRequest && listAdditionalItemsForRequest.length > 0 ) || (listAdditionalMedicinesForRequest && listAdditionalMedicinesForRequest.length > 0)) {
            <app-table-additional-items-prescription-release
              [listAdditionalItems]="listAdditionalItemsForRequest"
              [listAdditionalMedicines]="listAdditionalMedicinesForRequest">
            </app-table-additional-items-prescription-release>
          }
        </div>
      </div>
    </div>
  </form>
</div>

</div>
</div>
<div mat-dialog-footer class="footer-modal">
  <div class="footer-exam-modal-list row">
    <div class="col-8 col-md-4 col-sm-3">
      <button mat-flat-button color="accent" class="btn-block"
        (click)="openPrescriptionNonDispensationModalFromModal()">
        @if (isLoading == false) {
          <span>Não dispensar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-8 col-md-4 col-sm-3">
      <button mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">
        @if (isLoading == false) {
          <span>Cancelar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-8 col-md-4 col-sm-3">
      <button mat-flat-button color="primary" class="btn-block" (click)="submit()" [disabled]="!validated">
        @if (isLoading == false) {
          <span>Liberar</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>